'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ActiveUserNav = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _deep = require('helpers/deep');

var _FriendbuyWidget = require('components/Friendbuy/FriendbuyWidget');

var _ProductLinks = require('../NavItems/ProductLinks');

var _RafNavItem = require('../NavItems/RafNavItem');

var _UpcomingNavItem = require('../NavItems/UpcomingNavItem');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActiveUserNav = exports.ActiveUserNav = function ActiveUserNav(_ref) {
  var isLivePage = _ref.isLivePage,
      isGoPage = _ref.isGoPage,
      user = _ref.user;

  var _extractRafRewards = (0, _FriendbuyWidget.extractRafRewards)(user),
      rafSenderReward = _extractRafRewards.rafSenderReward;

  return _react2.default.createElement(
    _react.Fragment,
    null,
    !isLivePage && !isGoPage && _react2.default.createElement(_ProductLinks.ProductLinks, null),
    _react2.default.createElement(_UpcomingNavItem.UpcomingNavItem, { count: (0, _deep.deepExtract)('reservation_info.upcoming_reservation_count', user, 0) }),
    rafSenderReward && _react2.default.createElement(_RafNavItem.RafNavItem, {
      reward: rafSenderReward,
      user: user
    })
  );
};

ActiveUserNav.propTypes = {
  isLivePage: _propTypes2.default.bool,
  isGoPage: _propTypes2.default.bool,
  user: _propTypes2.default.object.isRequired
};